import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5","key":"svg-0"}],["path",{"d":"M3 9l3 6l3 -6","key":"svg-1"}],["path",{"d":"M9 20l6 -16","key":"svg-2"}]]

/**
 * IconKerning
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXIta2VybmluZyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTYgMTV2LTMuNWEyLjUgMi41IDAgMSAxIDUgMHYzLjVtMCAtMmgtNSIgLz4KICA8cGF0aCBkPSJNMyA5bDMgNmwzIC02IiAvPgogIDxwYXRoIGQ9Ik05IDIwbDYgLTE2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/kerning
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconKerning = createReactComponent('outline', 'kerning', 'Kerning', __iconNode);

export default IconKerning;